import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

const UnlinkDialog = ({
  loading,
  open,
  onClose,
  demoteEquipment,
  removedPoints,
  demotedPoints,
}) => (
  <Dialog open={open} maxWidth="sm" fullWidth>
    <DialogTitle>Confirm Removal</DialogTitle>
    <DialogContent>
      <Typography variant="subtitle1" component="label" htmlFor="myField">
        You are about to unlink the following points:
        <List sx={{ listStyleType: 'disc' }}>
          {removedPoints.map((point) => (
            <ListItem key={point.topic} sx={{ display: 'list-item', padding: 0 }}>
              <ListItemText primary={point.properties?.objectName} />
            </ListItem>
          ))}
        </List>
      </Typography>

      <Typography variant="subtitle1" component="label" htmlFor="myField">
        The following points are currently published for this equipment:
      </Typography>
      <List sx={{ listStyleType: 'disc' }}>
        {demotedPoints.map((point) => (
          <ListItem key={point.topic} sx={{ display: 'list-item', padding: 0 }}>
            <ListItemText primary={point.properties?.objectName} />
          </ListItem>
        ))}
      </List>

      <Typography variant="subtitle1" component="label" htmlFor="myField">
        Are you sure you want to proceed?
      </Typography>
    </DialogContent>
    <DialogActions style={{ justifyContent: 'space-between' }}>
      <Button variant="contained" onClick={() => onClose(false)} color="success" disabled={loading}>
        Cancel
      </Button>
      <Button variant="contained" onClick={demoteEquipment} color="error" disabled={loading}>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

export default UnlinkDialog;
